import toPrecision from './toPrecision.js';

const percentageToValue = (percentage, min, max, precision = 0) =>
  toPrecision((percentage * (max - min)) + min, precision);

export default percentageToValue;